export default __webpack_public_path__ + "static/media/image1.82d57775.png";